export const inventoryLevelsData = [
  { name: 'WH-North', stock: 12000 },
  { name: 'WH-South', stock: 9800 },
  { name: 'WH-East', stock: 15300 },
  { name: 'WH-West', stock: 8700 },
  { name: 'WH-Central', stock: 18900 },
]; 